import React from 'react';
import cx from 'clsx';
import moment from 'moment';
import {
  withStyles,
  TableCell as MuiTableCell
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TableCell = withStyles(theme => ({
  root: {
    padding: '6px',
    borderBottom: 'none'
  },
  head: {
    height: 20
  },
  body: {
    height: 'auto'
  },
  history: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 400
  },
  transaction: {
    // borderBottom: '2px '+theme.palette.custom.border+' solid',
  },
  striped: {
    backgroundColor: theme.palette.background.default
  }
}))(({
  model = 'transaction',
  striped = false,
  timestamp = false,
  variant = 'body',
  className,
  classes,
  vAlign = 'middle',
  children,
  sort = false,
  name = null,
  activeName,
  onNameChange,
  sortType,
  align,
  ...props
}) => (
  <MuiTableCell
    className={cx(classes.root, {
      [classes.head]: (variant === 'head'),
      [classes.body]: (variant === 'body'),
      [classes.transaction]: (variant === 'head' && model === 'transaction'),
      [classes.history]: (variant === 'head' && model === 'history'),
      [classes.striped]: striped
    }, className)}
    style={variant === 'body' ? { verticalAlign: vAlign } : {}}
    {...props}
  >
    <div style={{
      display: 'flex',
      justifyContent: align === 'center' ? 'center' : align === 'right' ? 'flex-end' : 'unset',
      alignItems: 'center'
    }}>
      <div style={{ cursor: sort ? 'pointer' : 'unset', width: 'fit-content' }} onClick={sort ? onNameChange(name) : () => {}}>
        {timestamp
          ? moment(children).format('L, HH:mm:ss')
          : children
        }
      </div>
      {sort &&
                <FontAwesomeIcon
                  icon={activeName === name ? sortType === 'ascending' ? 'caret-up' : 'caret-down' : 'caret-up'}
                  size='sm'
                  color={activeName === name
                    ? (variant === 'head' && model === 'history')
                      ? '#FFFFFF'
                      : '#0073D1'
                    : '#0000008a'
                  }
                  style={{
                    margin: '0px 5px',
                    cursor: 'pointer'
                  }}
                  onClick={onNameChange(name)}
                />
      }
    </div>
  </MuiTableCell>
))

export default TableCell;
